import { fromJS, OrderedMap } from "immutable";
import { Action, reducerFn, ReducerState } from "../../helpers/reducers";
import {
    AUTOCOMPLETE_SET,
    AUTOCOMPLETE_REMOVE,
    AUTOCOMPLETE_PAGE_REMOVE,
} from "./actions";

export interface AutoComplete {
    doc_id: string;
    page_id: string;
    list: any;
}
type AutoCompleteAction = Action<AutoComplete>;

function getId(payload: AutoComplete) {
    return `${payload.doc_id}-${payload.page_id}`;
}

const fnMap = {
    [AUTOCOMPLETE_SET]: (s: ReducerState, a: AutoCompleteAction) =>
        s.set(getId(a.payload), fromJS(a.payload.list)),
    [AUTOCOMPLETE_REMOVE]: (
        s: ReducerState,
        { payload }: AutoCompleteAction
    ) => {
        const prefix = `${payload.doc_id}-`;
        return OrderedMap(
            s.filterNot((_v, k) => (k as string).startsWith(prefix))
        );
    },
    [AUTOCOMPLETE_PAGE_REMOVE]: (
        s: ReducerState,
        { payload }: AutoCompleteAction
    ) => s.delete(getId(payload)),
};

const initialState = {};
export const autoCompleteReducer = reducerFn(
    "autocomplete",
    initialState,
    fnMap
);
